import { ValueRanges } from 'rlv-common';
import { ViewName } from '../../../../helpers/ViewName';
import { DecreasingNeedData } from '../../../../pages/needs/Needs.types';
import NeedsPageContainer from '../../../../pages/needs/NeedsPageContainer';
import { getAngebot, updateDecreasingNeedBlockData } from '../../../../services/api';
import {
  getTrackingBirthdate,
  mapFetchedNeedData,
  mapTrackingInsuredPerson,
} from '../../../../tracking/trackingFormating';
import { PagePercentage } from '../../../../types/PagePercentage';
import { createNeedPageSchema } from '../../../../validation/NeedPage';
import { FetchedTrackingData, StateDefinition } from '../../../StateMachine';
import { NavigationAction, StateName } from '../../../StateMachineTypes';

export const decreasingYearsTermState: StateDefinition<DecreasingNeedData> = {
  name: StateName.DECREASING_YEARS_TERM,
  percentage: PagePercentage.DECREASING_YEARS_TERM,
  trackingViewName: ViewName.BEDARFSANALYSE,
  createValidationSchema: (valueRanges: ValueRanges) => createNeedPageSchema(valueRanges),
  validInboundStates: [StateName.DECREASING_SUM_INSURED, StateName.DECREASING_INSURANCE_END_SUM],
  transitions: [
    {
      test: action => {
        const backAction =
          action === NavigationAction.BACK || action === NavigationAction.BROWSER_BACK;
        return backAction;
      },
      newState: StateName.DECREASING_SUM_INSURED,
    },
    {
      test: action => action === NavigationAction.NEXT,
      newState: StateName.DECREASING_INSURANCE_END_SUM,
    },
  ],
  onEnter: async (_, inputData) => {
    const response = await getAngebot(inputData.businessId);

    const fetchedTrackingData: FetchedTrackingData = {
      userAttributes: {
        ...mapTrackingInsuredPerson(),
        ...getTrackingBirthdate(response.livingConditionsModel),
      },
      tariffOptions: {
        ...mapFetchedNeedData(response.needSelectionModel),
      },
    };

    if (response.feeCalculationModel) {
      fetchedTrackingData.tariffOptions!.VersSumEJ = response.feeCalculationModel.sumInsured;
    }

    return {
      userInput: response.decreasingNeedModel,
      valueRanges: response.valueRanges,
      fetchedTrackingData,
    };
  },
  onExit: async (_, inputData) => {
    await updateDecreasingNeedBlockData(inputData.businessId, inputData.userInput);
    return {};
  },

  render: (inputData, handleAction, updateApp, _unused, updateDTMTracking) => {
    const userInput: DecreasingNeedData = inputData.userInput;
    return (
      <NeedsPageContainer
        businessId={inputData.businessId}
        inputData={inputData}
        updateApp={updateApp}
        storeState={{
          periodInYears: userInput.periodInYears,
          // We really need to send this values to update the tracker
          sumInsured: userInput.sumInsured,
          insuranceEndSum: userInput.insuranceEndSum,
          update: values => updateApp(values),
        }}
        valueRanges={inputData.valueRanges}
        handleAction={handleAction}
        updateDTMTracking={updateDTMTracking}
      />
    );
  },
};
